import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable, Subscription } from 'rxjs';
import { LessonModel } from '@generativ/much-smarter-models';

import { LessonService } from '../../exercise/shared/lesson.service';
import { UtilitiesService } from '../../../../shared/utilities.service';
import { FormService } from '../../../../core/services/form.service';
import { ContentViewerComponent } from '../../../../shared/content-viewer/content-viewer.component';
import { SpinnerComponent } from '../../../../shared/spinner/spinner.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-lesson-strategy-hypothesis',
    templateUrl: './lesson-strategy-hypothesis.component.html',
    styleUrls: ['./lesson-strategy-hypothesis.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ContentViewerComponent, FormsModule, ReactiveFormsModule, SpinnerComponent, AsyncPipe]
})
export class LessonStrategyHypothesisComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  lesson: Observable<LessonModel>;
  hypothesisForm: UntypedFormGroup;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private lessonService: LessonService,
              public utilitiesService: UtilitiesService,
              public formService: FormService) {
    this.hypothesisForm = this.formService.createForm(this.formOptions);
  }

  ngOnInit() {
    this.subscriptions.add(this.activatedRoute.params.subscribe((params) => {
      if (params['lessonId']) {
        this.lesson = this.lessonService.getLesson(params['lessonId']);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  handleOnSubmit() {
    if (this.formService.validateFormAndUpdateErrors(this.hypothesisForm)) {
      this.router.navigate([`../strategy-answer`], {relativeTo: this.activatedRoute});
    }
  }

  private get formOptions(): Record<string, unknown> {
    return {
      hypothesis: [
        null,
        Validators.compose( [
          Validators.required
        ])
      ]
    };
  }

}
